module.exports = __webpack_public_path__ + "982d7d415aa3dd23e0e81de6d23704a4.pdf";